import React from 'react';
import { Modal } from 'reactstrap';
import ReactLoading from 'react-loading';
import './LoadingDialog.css';

function LoadingDialog(props) {
  return (
    <div className="wrapper" >
      <Modal isOpen={props.isOpen} className="LoaderModal" >
        <ReactLoading type='spin' color='#2D9CDB' delay={0} />
      </Modal>
    </div>
  );
}

export default LoadingDialog;